import { Integration } from 'libs/end-to-end/src/types/databases/integrations/integration';
import { isValidAIInterviewerStartDate } from 'libs/end-to-end/src/ai-interviewer';
import { z } from 'zod';

/**
 * Validate the fields of a data set integration, prior to allowing the user to save the data set.
 */
export const validateDataSetIntegrationFields = ({
  integration,
}: {
  integration: Integration;
}): DataSetIntegrationFieldValidationError[] => {
  const errors: DataSetIntegrationFieldValidationError[] = [];

  if (
    integration.integrationType === 'Merge' &&
    !isValidAIInterviewerStartDate(integration.aiInterviewerStartDate)
  ) {
    errors.push('invalid-ai-interviewer-start-date');
  }

  return errors;
};

export const DataSetIntegrationFieldValidationError = z.enum([
  'invalid-ai-interviewer-start-date',
]);

export type DataSetIntegrationFieldValidationError = z.infer<
  typeof DataSetIntegrationFieldValidationError
>;
